import FileSaver from "file-saver";
import moment from "moment";
export default async ({
    name = "",
    date = undefined,
    id = ""
}) => {
    name += ` ${moment(date).format('YYYY-MM')}`;
    const innerHtml = `
      <caption>${name}</caption>
      ${document.getElementById(id).innerHTML.replace(/<table class="">/g, '<table border="1">')}
    `;

    var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
    var blob = new Blob([html], { type: "application/vnd.ms-excel" });
    await FileSaver.saveAs(blob, `${name}.xls`);
    return
}


// WEBPACK FOOTER //
// ./src/method/components/ExportExcel.js